module.exports = "/static/media/howToImage2.8dab2ccf.jpg";